import React from "react";
import { PatientRequestsParent } from "../components/patient-requests/PatientRequests";

const PatientRequests = () => {
  return <PatientRequestsParent />;
};

export default PatientRequests;
